import React from 'react';
import { motion } from 'framer-motion';
import LandingNavbar from '../../landing/LandingNavbar';
import styles from '../Auth.module.css';

/**
 * AuthLayout - Main layout wrapper for auth pages
 * Features animated background, glassmorphism card, and page transitions
 */
const AuthLayout = ({ 
  icon,
  title, 
  subtitle, 
  children, 
  footer,
  showBackgroundDecoration = true 
}) => {
  return (
    <>
      <LandingNavbar />
      <div className={styles['au-container']}>
        {/* Animated Background Decoration */}
        {showBackgroundDecoration && (
        <div className={styles['au-bg-decoration']}>
          <motion.div 
            className={`${styles['au-bg-circle']} ${styles['au-bg-circle--1']}`}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 0.4, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
          />
          <motion.div 
            className={`${styles['au-bg-circle']} ${styles['au-bg-circle--2']}`}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 0.4, scale: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
          />
          <motion.div 
            className={`${styles['au-bg-circle']} ${styles['au-bg-circle--3']}`}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 0.4, scale: 1 }}
            transition={{ duration: 1, delay: 0.6 }}
          />
        </div>
      )}

      {/* Glassmorphism Card */}
      <motion.div 
        className={styles['au-card']}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        {/* Card Header */}
        {(icon || title) && (
          <div className={styles['au-card__header']}>
            {icon && (
              <motion.div 
                className={styles['au-card__icon']}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.4, delay: 0.2, type: 'spring' }}
              >
                {icon}
              </motion.div>
            )}
            {title && (
              <motion.h2 
                className={styles['au-card__title']}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.3 }}
              >
                {title}
              </motion.h2>
            )}
            {subtitle && (
              <motion.p 
                className={styles['au-card__subtitle']}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.4, delay: 0.4 }}
              >
                {subtitle}
              </motion.p>
            )}
          </div>
        )}

        {/* Card Content */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {children}
        </motion.div>

        {/* Card Footer */}
        {footer && (
          <motion.div 
            className={styles['au-card__footer']}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.5 }}
          >
            {footer}
          </motion.div>
        )}
      </motion.div>
      </div>
    </>
  );
};

export default AuthLayout;
